import { connect } from 'react-redux';
import type { PastNextStepsProps } from '@/pages/CompanyReport/components/Past';
import { PastNextSteps } from '@/pages/CompanyReport/components/Past';
import {
  getSummary,
  getManagement,
} from '@/pages/CompanyReport/redux/selectors';
import { getPeople } from '@ducks/people/selectors';
import { get } from 'lodash';

type ContainerProps = {
  companyId: string;
  isDataMeaningless: boolean;
};

const mapStateToProps = (
  state,
  { companyId, isDataMeaningless }: ContainerProps
): PastNextStepsProps => {
  const summary = getSummary(state, { companyId });
  const management = getManagement(state, { companyId });
  const people = getPeople(state);
  const leader = people[management.leaderId];
  return {
    countryISO: summary.countryISO,
    scoreValue: summary.score.value,
    companyName: summary.shortName,
    scoreFuture: summary.score.future,
    scoreHealth: summary.score.health,
    tickerSymbol: summary.tickerSymbol,
    scoreDividend: summary.score.income,
    exchangeSymbol: summary.exchangeSymbol,
    CEOCompensation: get(leader, 'compensation', undefined),
    isDataMeaningless,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect(mapStateToProps)(PastNextSteps);
